
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/domain-name-disputes-landing-page",
      function () {
        return require("private-next-pages/domain-name-disputes-landing-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/domain-name-disputes-landing-page"])
      });
    }
  